import { useQuery } from '@tanstack/react-query';
import type { CursorPage, KeywordRun } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useKeywordRuns(projectId?: string, limit = 50) {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', projectId);
  params.set('limit', String(limit));
  return useQuery({
    queryKey: ['keyword-runs', { projectId, limit }],
    queryFn: () => apiGet<CursorPage<KeywordRun>>(`/v1/keyword-runs?${params.toString()}`),
  });
}
